import moment from 'moment';
import 'moment/locale/en-ca';
import 'moment/locale/de-at';
import { TcmCultureSystemService } from './tcm-culture-system-service';

export function localeIdFactory(tcmCultureSystemService: TcmCultureSystemService) {

    const locale =  tcmCultureSystemService.localeID;

    moment.locale(locale);

    console.log(`Current application locale: ${locale}`);

    return locale;
}
